import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";
import UserProfile from "@/views/ProfileView/UserProfile.vue";
import ChangePassword from "@/views/ProfileView/ChangePassword.vue";

const profileMenu = {
  path: "/profile",
  component: DashboardLayout,
  name: "profile",
  children: [
    {
      path: "info",
      name: "profile-info",
      component: UserProfile,
      meta: { requiresAuth: true, title: "마이페이지 > 내 정보" },
    },
    {
      path: "change-password",
      name: "change-password",
      component: ChangePassword,
      meta: { requiresAuth: true, title: "마이페이지 > 비밀번호 수정" },
    },
  ],
};

export default profileMenu;
